import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ContractInfoTO } from 'app/core/store/contract-info/contract-info.interface';
import { Observable, of } from 'rxjs';
import { util } from '../../util/util';

import { default as cachedResponseEpsCusToIncoterm } from './responses/getContractInfo-EPS-CUS-to-incoterm';
import { RestService } from './rest.service';
import { delay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ContractInfoRestService {
  private useMockRestData = false;

  constructor(private restService: RestService, private translate: TranslateService) {}

  getContractInfoOrderTypeToIncoterm(type: string, orderTypeId: string, showHidden: boolean, customerId?: string): Observable<ContractInfoTO> {
    if (this.useMockRestData) {
      const response = util.jsonDeepCopy(cachedResponseEpsCusToIncoterm);
      response.orderTypes[0].id = orderTypeId;
      return of(response).pipe(delay(1000));
    } else {
      const body = {
        type,
        orderType: orderTypeId,
        date: util.formatDate(new Date()),
        showHidden,
      };
      return this.restService.post<ContractInfoTO>(`/Contract/getContractInfo`, body, customerId);
    }
  }

  getContractInfoMaterials(
    type: string,
    orderTypeId: string,
    shippingCondition: string,
    fromId: string,
    toId: string,
    incoterm: string,
    showHidden: boolean, customerId?: string
  ): Observable<ContractInfoTO> {
    const body = {
      type,
      orderType: orderTypeId,
      date: util.formatDate(new Date()),
      shippingCondition,
      fromId,
      toId,
      showHidden,
      incoterm: incoterm || '',
      // depth: 'string'
    };
    return this.restService.post<ContractInfoTO>(`/Contract/getContractInfo`, body, customerId);
  }
}
